module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "academy"
  }, [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "academy__header"
  }, [_c('div', {
    staticClass: "academy__header-left"
  }, [_c('a', {
    staticClass: "academy__logo-link",
    attrs: {
      "href": "/calendar"
    }
  }, [_c('span', {
    staticClass: "academy__logo-back"
  }, [_vm._v("← Tilbage til")]), _vm._v(" "), _c('svg', {
    staticClass: "academy__logo",
    attrs: {
      "enable-background": "new 16.5 363.8 484.1 110.9",
      "viewBox": "16.5 363.8 484.1 110.9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "m118 473.3c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.6-15.2 11.3-26.9 11.3zm2.9-10.1c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.5 13.6 7.5zm71.7 10.7c-12.4 0-21.2-2.6-26.4-7.8s-7.8-14.1-7.8-26.7c0-13.9 3.3-24.5 9.9-31.9 6.6-7.3 16.6-11 30.1-11 6.6 0 11.4.6 14.3 1.8 3 1.2 4.5 3.1 4.5 5.5 0 3-1.1 5.9-3.2 8.6-7.5-3.9-14-5.9-19.3-5.9-7 0-11.9 2.2-14.9 6.7-2.9 4.4-4.4 11.4-4.4 20.9 0 9.8 1.4 17.1 4.3 22.1s8.1 7.4 15.7 7.4c5.8 0 12.5-1.9 20.1-5.8 1.7 2.3 2.5 4.7 2.5 7.1 0 2.9-2.6 5.1-7.8 6.6-5.2 1.6-11.1 2.4-17.6 2.4zm61.2-77.7c9.3 0 16.3 2.2 20.8 6.6s6.8 11.7 6.8 21.9c0 4.5-.8 7.6-2.4 9.3-1.6 1.8-5.1 2.6-10.6 2.6h-33.3c.1 8.2 1.7 14.6 4.9 19.3s8.8 7 16.9 7c7.5 0 14.6-2 21-5.9 2.2 2.2 3.2 4.4 3.2 6.9 0 3.4-2.8 5.7-8.3 7.1-5.6 1.4-11.8 2-18.8 2-12.9 0-22.1-2.7-27.7-8.2s-8.4-14.6-8.4-27.6c0-12.7 3.2-22.8 9.5-30.1 6.4-7.2 15.1-10.9 26.4-10.9zm-2.9 10.1c-5 0-8.8 1.8-11.5 5.4-2.6 3.6-4 9.2-4.3 16.9h7.8c8.2 0 13.9-.2 16.9-.5s4.7-.9 5.2-1.6c.5-.8.7-2.2.7-4.2 0-5-1.3-8.9-3.8-11.7-2.5-2.9-6.1-4.3-11-4.3zm56.5.9c5-3.3 9.9-5.8 14.7-7.3 4.9-1.6 9.2-2.3 13-2.3 6.7 0 11.7 1.5 15.1 4.6s5.1 9 5.1 17.7c0 27 .4 41.4 1.2 43s2.6 2.4 5.4 2.3c.6 1.5.8 2.9.8 4.4 0 1.4-.4 2.3-1.3 2.7-.9.5-2.4.7-4.8.7-7 0-11.3-.1-12.8-.3-1.6-.2-2.6-.7-3.2-1.6s-.8-2.3-.8-4.4v-32.5c0-10.4-1.1-17.2-3.3-20.7-2.2-3.4-5.7-5.1-10.6-5.1-4.2 0-7.8 1.2-10.8 3.5s-4.6 6.6-4.6 12.7v15.9c0 8.9.2 17.1.5 24.6h8.4c.6 1.3.9 2.7.9 4.2 0 1.4-.3 2.3-.8 2.8-.6.5-1.6.8-3.2.8h-29.6c-.7-1.6-1-3.1-1-4.5 0-1.1.3-1.9.8-2.5.6-.5 1.5-.8 2.7-.8h5.2c.4-8 .6-17.8.6-29.4 0-14.8-.6-23.4-1.7-25.8-1.2-2.4-3.4-3.5-6.6-3.5-.7-1.4-1-2.9-1-4.4 0-1.4.5-2.2 1.6-2.6s7.7-.8 20-1.2c.4 2.4.4 5.3.1 9zm156.5 66.7c-10.9 0-18.9-2.9-24.1-8.7-5.1-5.8-7.7-14.5-7.7-26.2 0-13.4 3.1-23.8 9.3-31.3 6.2-7.4 15.2-11.2 26.9-11.2 10.9 0 18.9 2.9 24.1 8.7 5.1 5.8 7.7 14.5 7.7 26.2 0 13.4-3.1 23.8-9.3 31.2-6.2 7.5-15.2 11.3-26.9 11.3zm2.9-10.2c5.7 0 9.9-2.2 12.4-6.5 2.6-4.3 3.8-11 3.8-20 0-10.4-1.3-18-4-23.1-2.6-5-7.2-7.5-13.6-7.5-5.7 0-9.9 2.2-12.4 6.5-2.6 4.3-3.8 11-3.8 20.1 0 10.3 1.3 18 4 23 2.6 5 7.1 7.6 13.6 7.5zm-422.3 10.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7zm352.3 18.1c1.6 0 3.1-.1 4.6-.3 2.3-.3 4.6-.7 6.9-1.4 3.9-1.1 8.2-3.1 12.7-5.8 8.4-5.9 13.5-14.9 13.5-25.1-.1-4.2-.1-9-.1-14.4v-54c0-2.5-.7-8.6-7.7-8.6-8.8 0-10 6.7-9.1 12.9.7 4.6.9 4.8 1.1 9s.3 8.2.3 11.9c-1.8-.5-3.6-.8-5.6-1.1s-4.4-.5-7.3-.5c-12.2 0-21.4 3.7-27.5 11s-9.2 18-9.2 31.9c0 12.7 2.3 21.6 6.9 26.7s11.2 7.7 19.7 7.7h1.1zm-6.6-17.8c-2.6-5.2-3.8-12.3-3.8-21.3 0-10.3 1.3-17.6 4-21.8s7-6.3 13.1-6.3c3.3 0 6.3.4 8.9 1.2s4.8 1.7 6.6 2.7v30.8c0 8.2-.5 13.3-1.5 15.4s-2.8 3.8-5.5 5.1-5.6 1.9-8.8 1.9c-6.1.1-10.4-2.5-13-7.7z"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "academy__header-divider"
  }, [_vm._v("Academy")]), _vm._v(" "), _c('span', {
    staticClass: "academy__header-sep"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "academy__school-name"
  }, [_vm._v(_vm._s(_vm.schoolName))])]), _vm._v(" "), _c('nav', {
    staticClass: "academy__tabs"
  }, [_vm._l((_vm.academyTabs), function(tab) {
    return [(!tab.comingSoon) ? _c('button', {
      key: tab.id,
      staticClass: "academy__tab",
      class: {
        'academy__tab--active': _vm.activeShowcaseId === tab.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.switchShowcase(tab.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab.label) + "\n        ")]) : _c('span', {
      key: 'soon-' + tab.label,
      staticClass: "academy__tab academy__tab--soon",
      attrs: {
        "aria-disabled": "true"
      }
    }, [_c('span', {
      staticClass: "academy__tab-label"
    }, [_vm._v(_vm._s(tab.label))]), _vm._v(" "), _c('span', {
      staticClass: "academy__tab-soon-note"
    }, [_vm._v("Kommer snart")])])]
  })], 2)]), _vm._v(" "), (!_vm.isLoading && _vm.videos.length) ? _c('div', {
    staticClass: "academy__body"
  }, [_c('div', {
    staticClass: "academy__player-section"
  }, [_c('div', {
    staticClass: "academy__player-wrap"
  }, [_c('iframe', {
    ref: "vimeoPlayer",
    attrs: {
      "src": _vm.activeVideoSrc,
      "frameborder": "0",
      "allow": "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "academy__video-info"
  }, [_c('h2', {
    staticClass: "academy__video-title"
  }, [_vm._v(_vm._s(_vm.activeVideo.name))]), _vm._v(" "), (_vm.activeVideo.description_html) ? _c('div', {
    staticClass: "academy__video-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.activeVideo.description_html)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "academy__playlist"
  }, _vm._l((_vm.videos), function(video, index) {
    return _c('div', {
      key: video.uri,
      staticClass: "academy__playlist-item",
      class: {
        'academy__playlist-item--active': _vm.activeVideo && _vm.activeVideo.uri === video.uri
      },
      on: {
        "click": function($event) {
          return _vm.selectVideo(video)
        }
      }
    }, [_c('div', {
      staticClass: "academy__playlist-item-left"
    }, [_c('i', {
      staticClass: "academy__play-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "academy__playlist-number"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', {
      staticClass: "academy__playlist-name"
    }, [_vm._v(_vm._s(video.name))])]), _vm._v(" "), _c('span', {
      staticClass: "academy__playlist-duration"
    }, [_vm._v("(" + _vm._s(_vm.formatDuration(video.duration)) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "academy__playlist-progress"
    }, [_c('div', {
      staticClass: "academy__playlist-progress-bar",
      style: ({
        width: _vm.getProgress(video) + '%'
      })
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "academy__loading"
  }, [_c('div', {
    staticClass: "academy__spinner"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.videos.length) ? _c('div', {
    staticClass: "academy__empty"
  }, [_c('p', [_vm._v("Ingen videoer fundet.")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "academy__hero"
  }, [_c('div', {
    staticClass: "academy__hero-bg"
  }, [_c('div', {
    staticClass: "academy__hero-bg__triangle"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-644890bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Academy/Academy.vue
// module id = 1963
// module chunks = 1